import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/**
 * Owns the single share entry point on votePreview (N7): while the share panel is
 * on screen the context action bar hides its share button and its share menu entry;
 * once the panel is closed the bar takes over. Never both, never neither.
 *
 * Deliberately in-memory and without any poll bookkeeping — every votePreview init
 * decides the start state again from the response count (N7.2).
 */
@Injectable({
    providedIn: 'root'
})
export class SharePanelStateService {
    private readonly visible = new BehaviorSubject<boolean>(false);

    /** synchronous read for the templates of panel and context action bar */
    get isPanelVisible(): boolean {
        return this.visible.value;
    }

    /** for work that only pays off once the card is on screen, e.g. building the qr */
    get panelVisible$(): Observable<boolean> {
        return this.visible.asObservable();
    }

    /** called on poll preview init (reset) and by the toolbar share button on votePreview */
    public showPanel(): void {
        this.visible.next(true);
    }

    public hidePanel(): void {
        this.visible.next(false);
    }
}
